import { render, staticRenderFns } from "./OldBibaran.vue?vue&type=template&id=11443cac&"
import script from "./OldBibaran.vue?vue&type=script&lang=js&"
export * from "./OldBibaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports